<template lang="pug">
  div
    v-simple-table(fixed-header).mb-8
      thead
        tr
          th(@click="sort('lastName', sortName)").text-left.handpointer
            span Scholar Name
            v-icon(v-if="typeof sortName !== 'undefined'") {{ chevron(sortName) }}
          th(@click="sort('ambition', sortAmbition)").text-left.handpointer
            span Ambition
            v-icon(v-if="typeof sortAmbition !== 'undefined'") {{ chevron(sortAmbition) }}
          th.text-left Story
          th
      tbody
        tr(
          v-for="(beneficiary, i) in beneficiaryList" 
          :key="i"
          :style=" i%2 === 0 ? '' : 'background: #0000000d'"
        )
          td 
            v-row
              v-col(cols="auto")
                v-avatar(
                  size="40"
                  left
                )
                  v-img(
                    height="40"
                    :src="picURL(beneficiary) || '@/assets/avatar-placeholder.png'"
                  ) 
              v-col(cols="8").align-self-center
                p(style="min-height: 20px;").mb-0 {{ lastName(beneficiary) }}, {{ firstName(beneficiary) }} 
          td {{ ambition(beneficiary) }}
          td {{ story(beneficiary) }}
          td
            v-menu(
              close-on-click
              close-on-content-click
              bottom
              left
              offset-x
              offset-y
            )
              template(v-slot:activator="{ on }")
                v-btn(
                  icon
                  v-on="on"
                )
                  v-icon(small) mdi-dots-horizontal
              v-list(dense)
                v-list-item(
                  v-for="(menuItem, i) in menuItems"
                  :key="i"
                  @click.stop="menuItem.action(beneficiary)"
                  v-if="menuItem.show"
                )
                  v-icon(
                    :color="menuItem.color"
                    small
                    left
                  ) {{ menuItem.icon }}
                  v-list-item-content(:class="menuItem.textColor") 
                    v-list-item-title(v-text="menuItem.text")
</template>

<script>
import placeholderImg from '@/assets/avatar-placeholder.png';

export default {
  props: {
    beneficiaryList: {
      type: Array
    },
    isUnpublishedTab: {
      type: Boolean
    }
  },
  data () {
    return {
      sortName: undefined,
      sortAmbition: undefined,
      menuItems: [
        {
          text: 'View Profile',
          icon: 'mdi-eye',
          action: this.view,
          show: true
        },
        {
          text: 'Publish Profile',
          icon: 'mdi-flag-plus',
          action: this.publish,
          show: !this.isUnpublishedTab
        },
        {
          text: 'Unpublish Profile',
          icon: 'mdi-flag-minus',
          action: this.publish,
          show: this.isUnpublishedTab
        },
        {
          text: 'Delete',
          icon: 'mdi-close',
          color: 'red',
          textColor: 'red--text',
          action: this.remove,
          show: true
        }
      ]
    };
  },
  methods: {
    sort (key, sort = true) {
      function compare (a, b) {
        if (key === 'lastName') {
          if (a.name[key] > b.name[key]) return sort ? 1 : -1;
          if (b.name[key] > a.name[key]) return sort ? -1 : 1;
        } else {
          if (a[key] > b[key]) return sort ? 1 : -1;
          if (b[key] > a[key]) return sort ? -1 : 1;
        }

        return 0;
      }

      this.beneficiaryList.sort(compare);

      switch (key) {
        case 'lastName':
          this.sortName = !sort;
          this.sortAmbition = undefined;
          this.sortStory = undefined;
          break;
        case 'ambition':
          this.sortAmbition = !sort;
          this.sortName = undefined;
          this.sortStory = undefined;
          break;
      }
    },
    picURL (beneficiary) {
      return beneficiary.picURL || placeholderImg;
    },
    firstName (beneficiary) {
      const name = beneficiary ? beneficiary.name : {};
      return name.firstName || 'Unnamed';
    },
    lastName (beneficiary) {
      const name = beneficiary ? beneficiary.name : {};
      return name.lastName || 'Last';
    },
    ambition (beneficiary) {
      const ambition = beneficiary ? beneficiary.ambition : {};
      return ambition || 'Ambition';
    },
    story (beneficiary) {
      const story = beneficiary ? beneficiary.storyShort : {};
      return story || "Beneficiary's story";
    },
    chevron (sort) {
      return sort ? 'mdi-chevron-down' : 'mdi-chevron-up';
    },
    async publish (beneficiary) {
      try {
        this.$setLoading(true);

        if (this.isUnpublishedTab) {
          await this.$store.dispatch('beneficiaries/update', {
            id: beneficiary.id,
            $publish: !this.isUnpublishedTab
          });
          await this.$store.dispatch(
            'fundings/resolve',
            {
              id: beneficiary.activeFunding,
              beneficiary: beneficiary.id,
              $resolve: true
            }
          );
        } else {
          await this.$store.dispatch('beneficiaries/update', {
            id: beneficiary.id,
            $publish: !this.isUnpublishedTab
          });
        }
        this.$enqueueSnack(`Successfully ${!this.isUnpublishedTab ? 'published' : 'unpublished'} scholar`);
      } catch (err) {
        console.log(err);
        this.$enqueueSnack(err);
      } finally {
        this.$setLoading(false);
        this.$emit('reload');
      }
    },
    async remove (beneficiary) {
      try {
        this.$setLoading(true);
        await this.$store.dispatch('beneficiaries/delete', { id: beneficiary.id });
        this.$enqueueSnack('Scholar deleted');
      } catch (err) {
        console.log(err);
        this.$enqueueSnack(err);
      } finally {
        this.$setLoading(false);
      }
    },
    view (beneficiary) {
      this.$router.push(
        {
          name: 'viewscholar',
          params: {
            scholarId: beneficiary.id
          }
        }
      );
    }
  }
};
</script>

<style scoped>
.handpointer {
  cursor: pointer;
}
</style>